/**
 * @generated SignedSource<<a4e4a351519be3d605ae16cafba86e62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useRecentItemsPaged$data = {
  readonly jira: {
    readonly _recentItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "JiraBoard";
          readonly boardId: AGG$Long | null | undefined;
          readonly boardUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
          readonly name: string | null | undefined;
        } | {
          readonly __typename: "JiraCustomFilter";
          readonly filterId: string;
          readonly filterName: string;
          readonly filterUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
        } | {
          readonly __typename: "JiraDashboard";
          readonly dashboardId: AGG$Long | null | undefined;
          readonly dashboardTitle: string | null | undefined;
          readonly dashboardUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
        } | {
          readonly __typename: "JiraIssue";
          readonly id: string;
          readonly issueId: string;
          readonly issueWebUrl: AGG$URL | null | undefined;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
          readonly summaryField: {
            readonly text: string | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraPlan";
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
          readonly planId: AGG$Long | null | undefined;
          readonly planTitle: string | null | undefined;
          readonly scenario: {
            readonly scenarioId: AGG$Long | null | undefined;
          } | null | undefined;
        } | {
          readonly __typename: "JiraProject";
          readonly avatar: {
            readonly large: string | null | undefined;
          } | null | undefined;
          readonly defaultNavigationItem: {
            readonly url?: string | null | undefined;
          } | null | undefined;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly key: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
          readonly projectId: string | null | undefined;
          readonly title: string;
        } | {
          readonly __typename: "JiraServiceManagementQueue";
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
          readonly queueId: AGG$Long | null | undefined;
          readonly queueTitle: string | null | undefined;
          readonly queueUrl: AGG$URL | null | undefined;
        } | {
          readonly __typename: "JiraSystemFilter";
          readonly filterId: string;
          readonly filterName: string;
          readonly filterUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null | undefined;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  };
  readonly " $fragmentType": "useRecentItemsPaged";
};
export type useRecentItemsPaged$key = {
  readonly " $data"?: useRecentItemsPaged$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRecentItemsPaged">;
};

import useRecentItemsPaginationQuery_graphql from './useRecentItemsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "_recentItems"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "lastViewedTimestamp"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "alias": "filterName",
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "filterUrl"
  },
  {
    "kind": "ScalarField",
    "name": "filterId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "keyword"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": useRecentItemsPaginationQuery_graphql
    }
  },
  "name": "useRecentItemsPaged",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "_recentItems",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "keyword",
                    "variableName": "keyword"
                  }
                ],
                "kind": "ObjectValue",
                "name": "filter"
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "PROJECT",
                  "FILTER",
                  "DASHBOARD",
                  "BOARD",
                  "QUEUE",
                  "ISSUE",
                  "PLAN"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "__useRecentItemsPaged__recentItems_connection",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "text"
                              }
                            ]
                          },
                          {
                            "alias": "issueWebUrl",
                            "kind": "ScalarField",
                            "name": "webUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "issueId"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "title",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "JiraNavigationItem",
                                "abstractKey": "__isJiraNavigationItem"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "large"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          }
                        ],
                        "type": "JiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "planId"
                          },
                          {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "scenarioId"
                              }
                            ]
                          },
                          {
                            "alias": "planTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          }
                        ],
                        "type": "JiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardId"
                          }
                        ],
                        "type": "JiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "dashboardTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                          }
                        ],
                        "type": "JiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "JiraSystemFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v3/*: any*/),
                        "type": "JiraCustomFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "queueTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueId"
                          }
                        ],
                        "type": "JiraServiceManagementQueue"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "b44cda8ef2e6ca19c983047f10c8ea51";

export default node;
